import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SidenavCollapsibleGroup } from './Sidenav.CollapsibleGroup/Sidenav.CollapsibleGroup.es.js';
import { SidenavProvider } from './Sidenav.Context/Sidenav.Context.es.js';
import { SidenavGroup } from './Sidenav.Group/Sidenav.Group.es.js';
import { SidenavItem } from './Sidenav.Item/Sidenav.Item.es.js';
import { SidenavUserMenu } from './Sidenav.UserMenu/Sidenav.UserMenu.es.js';

const Sidenav = ({ children, className, variant = 'light', collapsed = false, ...props })=>{
    return jsx(SidenavProvider, {
        collapsed: collapsed,
        variant: variant,
        children: jsx("nav", {
            className: classNames('cb-sidenav', variant, {
                collapsed
            }, className),
            "data-testid": "sidenav",
            ...props,
            children: children
        })
    });
};
Sidenav.displayName = 'Sidenav';
Sidenav.Item = SidenavItem;
Sidenav.UserMenu = SidenavUserMenu;
Sidenav.Group = SidenavGroup;
Sidenav.CollapsibleGroup = SidenavCollapsibleGroup;

export { Sidenav, Sidenav as default };
//# sourceMappingURL=Sidenav.es.js.map
